'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function DashboardAccountDevices() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [];
  this._showFrenchLanguage = false;
  this._indexTrustedDevices = 'account.index_authenticated_devices';

  this.init = function () {
    this._getTrustedDevices();

    this._browserlanguage = document.documentElement.lang.toLowerCase();
    this._userProvence = this.presenter.getModelProperty('account.province');
    if ((this._browserlanguage === 'fr' || this._browserlanguage === 'fr-fr' || this._browserlanguage === 'fr-ca') && this._userProvence === 'QC') {
      this._showFrenchLanguage = true;
    }
  };

  this.initAllReady = function () {
    this._setComputedVariables();
  };

  this.destroy = function () {};

  this._getTrustedDevices = function (item, data) {
    if (!this.presenter.models.authenticatedDevices) {
      if (this.presenter.hasAction(this._indexTrustedDevices)) {
        this.presenter.createModel('authenticatedDevices', { action: this._indexTrustedDevices }, this._displayAllDevices.bind(this));
      }
    } else {
      this._displayAllDevices(this.presenter.models.authenticatedDevices);
    }
  };

  this._displayAllDevices = function (data, response) {
    // Helper function
    function mogoDevicesFilter(device) {
      return device.application === 'mogo';
    }
    // Helper function
    function nonMogoDevicesFilter(device) {
      return device.application !== 'mogo';
    }

    // Use helper functions above to filter out mogo devices
    var mogoDevices = data.authenticated_devices.filter(mogoDevicesFilter);
    var nonMogoDevices = data.authenticated_devices.filter(nonMogoDevicesFilter);

    // Add Filtered arrays into model data
    var formattedData = _extends({}, data, {
      mogo_authenticated_devices: mogoDevices,
      mogo_trade_authenticated_devices: nonMogoDevices
    });

    this.presenter.updateModel('authenticatedDevices', formattedData);

    // Mogo Devices - loop through markup and add Mogo devices
    var mogoRepeater = $('.mogo-devices .item--device.hide', this.node);
    var mogoBaseHTML = mogoRepeater.parent().html();
    for (var index = 0; index < mogoDevices.length; index++) {
      var model = 'authenticatedDevices.mogo_authenticated_devices[' + index + ']';
      var newItem = $(mogoBaseHTML.replace('{Index}', index).replace('{MogoRepeatedDevice}', model));
      var button = newItem.find('.edit--link');
      newItem.addClass('item--generated').removeClass('hide');
      button.click($.proxy(this._removeDevice, this, button, formattedData.mogo_authenticated_devices[index]));

      mogoRepeater.before(newItem);
    }

    // Mogo Trade Devices - loop through markup and add Mogo Trade Devices
    var mogoTradeRepeater = $('.mogoTrade-devices .item--device.hide', this.node);
    var mogoTradeBaseHTML = mogoTradeRepeater.parent().html();
    for (var _index = 0; _index < nonMogoDevices.length; _index++) {
      var _model = 'authenticatedDevices.mogo_trade_authenticated_devices[' + _index + ']';
      var _newItem = $(mogoTradeBaseHTML.replace('{Index}', _index).replace('{MogoTradeRepeatedDevice}', _model));
      var _button = _newItem.find('.edit--link');
      _newItem.addClass('item--generated').removeClass('hide');
      _button.click($.proxy(this._removeDevice, this, _button, formattedData.mogo_trade_authenticated_devices[_index]));

      mogoTradeRepeater.before(_newItem);
    }
    var length = data.authenticated_devices.length;

    this.presenter.scanDOM(this.node);
    this.analytics.forcePushEvent('account-devices', {
      AuthenticatedDevices: [length]
    });
  };

  this._findDeviceIndex = function (item, data) {
    for (var index = 0; index < data.length; index++) {
      if (data[index].id === item.id) {
        return index;
      }
    }
    return -1;
  };

  this._removeDevice = function (button, model, event) {
    event.preventDefault();
    if (!this.presenter.models.deviceToDelete) {
      button.addClass('button-loading');
      this.presenter.createModel('deviceToDelete', { data: model });
      this.presenter.performAction('deviceToDelete.deauthenticate_device_by_id', null, $.proxy(this._onRemoveDevice, this, button, model));
    }
  };

  this._onRemoveDevice = function (button, item, data, response) {
    this.notifications = $('#Notification');
    var notificationComponent = this.notifications.mogo();
    if (response != 200) {
      this.msg = 'Weird. Looks like a system error. Try again?';
      if (this._showFrenchLanguage) {
        this.msg = 'Bizarre. On dirait une erreur syst\xE8me. R\xE9essayez ?';
      }
      notificationComponent.create({
        msg: this.msg
      });
      var issue = 'SOA ' + data.errors[0].key;
      this.analytics.forcePushEvent('connection-issue', {
        Issue: [issue],
        ProductAffected: ['MogoMember']
      });
    } else {
      this.message = '\u201C' + item.device_name + '\u201D was successfully removed';
      if (this._showFrenchLanguage) {
        this.message = 'Le dispositif a \xE9t\xE9 retir\xE9 avec succ\xE8s';
      }

      notificationComponent.create({
        type: 'success',
        msg: this.message
      });
      var devices = this.presenter.models.authenticatedDevices;
      var index = this._findDeviceIndex(item, devices.authenticated_devices);
      if (index !== -1) {
        devices.authenticated_devices.splice(index, 1);
      }
      $('.item--generated', this.node).remove();
      this._displayAllDevices(devices);
    }
    button.removeClass('button-loading');
    delete this.presenter.models.deviceToDelete;
  };

  this._setComputedVariables = function () {
    var _this = this;

    this.presenter.addComputedVariable('is_mogo_trade_management_enabled', null, function () {
      return _this.presenter.featureControls.isEnabled('ManageMogoTradeDevice');
    });
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('is_mogo_trade_management_enabled');
  };
}